module.exports = __webpack_public_path__ + "static/media/Montserrat-SemiBold.c641dbee.ttf";